import { ValueType } from 'realgrid';
import { getCategoryList } from 'api/materialProperty/materialProperty';

export const fields = [
  {
    fieldName: 'category',
    dataType: ValueType.TEXT,
  },
  {
    fieldName: 'material',
    dataType: ValueType.TEXT,
  },
  {
    fieldName: 'mw',
    dataType: ValueType.NUMBER,
  },
  {
    fieldName: 'density',
    dataType: ValueType.NUMBER,
  },
  {
    fieldName: 'remark',
    dataType: ValueType.TEXT,
  },
  {
    fieldName: 'reg_date',
    dataType: ValueType.TEXT,
  },
  {
    fieldName: 'reg_user',
    dataType: ValueType.TEXT,
  },
];

// 카테고리 데이터를 동적으로 로드하는 함수
let categoryValues = [];
let categoryLabels = [];

export async function loadCategoryData() {
  try {
    const response = await getCategoryList();
    const categories = response.data.data || [];
    categoryValues = categories.map(item => item.category_value);
    categoryLabels = categories.map(item => item.category_name);
  } catch (error) {
    console.error('카테고리 로드 실패:', error);
    categoryValues = [];
    categoryLabels = [];
  }
}

export const columns = [
  {
    name: 'category',
    fieldName: 'category',
    sortable: false,
    lookupDisplay: true,
    values: [], // 동적으로 설정됨
    labels: [], // 동적으로 설정됨
    editor: {
      type: 'dropdown',
      textReadOnly: true,
      domainOnly: true,
      dropDownWhenClick: true,
    },
    header: {
      text: '구분',
      styleName: 'orange-column',
    },
    editButtonVisibility: 'always',
    editable: true,
    width: 120,
  },
  {
    name: 'material',
    fieldName: 'material',
    type: 'data',
    styles: {
      textAlignment: 'center',
      background: '#f5f5f5', // 읽기 전용 표시
    },
    header: {
      text: '원료',
      showTooltip: false,
    },
    editable: false, // 수정 모드에서는 원료명 변경 불가
    width: 200,
  },
  {
    name: 'mw',
    fieldName: 'mw',
    type: 'data',
    styles: {
      textAlignment: 'center',
    },
    header: {
      text: 'Mw (g/mol)',
      showTooltip: false,
    },
    editable: true,
    editor: {
      type: 'number',
      positiveOnly: true,
      integerOnly: false,
    },
    numberFormat: '#,##0.0000',
    dataType: 'number',
    width: 120,
  },
  {
    name: 'density',
    fieldName: 'density',
    type: 'data',
    styles: {
      textAlignment: 'center',
    },
    header: {
      text: 'Density (g/cm3)',
      showTooltip: false,
    },
    editable: true,
    editor: {
      type: 'number',
      positiveOnly: true,
      integerOnly: false,
    },
    numberFormat: '#,##0.0000',
    dataType: 'number',
    width: 140,
  },
  {
    name: 'remark',
    fieldName: 'remark',
    type: 'data',
    styles: {
      textAlignment: 'left',
    },
    header: {
      text: '비고',
      showTooltip: false,
    },
    editable: true,
    width: 200,
  },
  {
    name: 'reg_date',
    fieldName: 'reg_date',
    type: 'data',
    styles: {
      textAlignment: 'center',
      background: '#f5f5f5', // 읽기 전용 표시
    },
    header: {
      text: '등록일',
      showTooltip: false,
    },
    editable: false,
    width: 100,
  },
  {
    name: 'reg_user',
    fieldName: 'reg_user',
    type: 'data',
    styles: {
      textAlignment: 'center',
      background: '#f5f5f5', // 읽기 전용 표시
    },
    header: {
      text: '등록자',
      showTooltip: false,
    },
    editable: false,
    width: 100,
  },
];

// 카테고리 컬럼 업데이트 함수
export function updateCategoryColumn() {
  const categoryColumn = columns.find(col => col.fieldName === 'category');
  if (categoryColumn) {
    categoryColumn.values = categoryValues;
    categoryColumn.labels = categoryLabels;
  }
} 